import { axiosMaximus } from './axiosMaximus';
import { makeConfig, makeUrl } from './basicHelpers';

export const basicRequestPatch = async (relativeUrl: string, data: any, requestConfig = {}) => {
  try {
    return await axiosMaximus.patch(makeUrl(relativeUrl), data, makeConfig(requestConfig));
  } catch (error) {
    // @ts-ignore
    delete error.stack;
    throw error;
  }
};
